<app-progress-spinner [hidden]="!((authLoading$ | async) || (userLoading$ | async))"></app-progress-spinner>

<div class="auth-layout">
  <div class="container-fluid">
    <div class="row">
      <div class="auth-layout__logo col-md-6">
        <a routerLink="/">
          <img src="assets/icon/logo-light.svg"
               alt="Softhread"
          >
        </a>
      </div>
      <div class="auth-layout__form col-md-6">
        <div class="mx-w-490">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
